import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { getInformationForDay } from '@/domain/termine/shared/utils/dateValidations';
import { Day } from '@/domain/termine/type';
import { useTranslation } from 'react-i18next';

interface ListWeekProps {
  week: Day[];
}

export function ListWeekHeader({ week }: ListWeekProps) {
  const { monthDate } = useCalendarContext();
  const { t } = useTranslation();
  const firstDay = week[0];
  const { calendarWeek } = getInformationForDay(firstDay, monthDate.month);

  const weekStart = firstDay.startOf('week');
  const weekEnd = firstDay.endOf('week');
  return (
    <div className="w-full text-neutrals-N700 text-xs flex gap-1 pt-4">
      {t('general.date.calendarWeek')} {calendarWeek}
      <div>
        ({weekStart.format('DD.MM.')} - {weekEnd.format('DD.MM.')})
      </div>
    </div>
  );
}
